<template>
  <div>
    <v-tabs v-model="tab">
      <v-tab v-for="item in tabs" :key="item.name">
        {{ item.name }}
      </v-tab>
    </v-tabs>

    <v-tabs-items v-model="tab">
      <v-tab-item v-for="item in tabs" :key="item.name" class="pb-16 pt-5">
        <component :is="item.component" />
      </v-tab-item>
    </v-tabs-items>
  </div>
</template>

<script>
import AppModelLog from "@/components/apps/AppModelLog";
import AppTableLog from "@/components/apps/AppTableLog";

export default {
  name: "AppLog",

  components: { AppModelLog, AppTableLog },
  data() {
    return {
      tab: 0,
      tabs: [
        {
          component: "AppModelLog",
          name: "Модель",
        },
        {
          component: "AppTableLog",
          name: "Шаги",
        },
      ],
    };
  },

  methods: {},
};
</script>

<style lang="scss" scoped></style>
